import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";

interface DiagnosticAnalysis {
  potentialDiagnoses: Array<{
    condition: string;
    probability: number;
    reasoning: string;
    clinicalPearls?: string[];
    severity: string;
    requiredTests?: string[];
  }>;
  clinicalReasoningPath: string[];
  scientificBasis?: string[];
}

interface DetailButtonProps {
  diagnosticAnalysis: DiagnosticAnalysis;
}

const DetailButton = ({ diagnosticAnalysis }: DetailButtonProps) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="mt-6">
      <div className="text-center">
        <Button
          variant="outline"
          onClick={() => setShowDetails(!showDetails)}
          className="text-blue-600 border-blue-600 hover:bg-blue-50"
        >
          {showDetails ? (
            <>
              Hide Details <ChevronUp className="ml-2 h-4 w-4" />
            </>
          ) : (
            <>
              Click here for further information <ChevronDown className="ml-2 h-4 w-4" />
            </>
          )}
        </Button>
      </div>

      {showDetails && (
        <div className="mt-6 space-y-6">
          {/* Clinical Reasoning Process */}
          <Card className="p-6 bg-gray-50">
            <h4 className="text-lg font-semibold text-gray-800 mb-4">Clinical Reasoning Process</h4>
            <div className="space-y-2">
              {diagnosticAnalysis.clinicalReasoningPath.map((step, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium flex-shrink-0 mt-0.5">
                    {index + 1}
                  </div>
                  <p className="text-sm text-gray-700">{step}</p>
                </div>
              ))}
            </div>
          </Card>

        </div>
      )}
    </div>
  );
};

export default DetailButton;